import useIsVisible from '@unctad-infovis/general-tools/helpers/UseIsVisible.js';
import { getLocale } from '../../i18n.js';
import RollingNumberLocalized from './RollingNumberLocalized.jsx';
import './TileRow.css';

export default function TileRow({ eyebrow, groups = [] }) {
  const [groupsRef, groupsInView] = useIsVisible(0.3);
  const locale = getLocale();

  return (
    <div className="tr_container">
      <div className="tr_eyebrow">
        <span className="tr_eyebrow_line" />
        {eyebrow}
      </div>
      <div className={`tr_groups${groupsInView ? ' tr_groups--inview' : ''}`} ref={groupsRef}>
        {groups.map(group => {
          const isFeature = group.tiles.length === 1;
          return (
            <div className="tr_group" key={group.title}>
              <h2 className="tr_title">{group.title}</h2>
              {group.description && <p className="tr_desc">{group.description}</p>}
              <div className={`tr_grid${isFeature ? ' tr_grid--feature' : ''}`}>
                {group.tiles.map((tile, idx) => (
                  <div className={`tr_tile${isFeature ? ' tr_tile--feature' : ''}`} key={tile.label} style={{ transitionDelay: `${idx * 150}ms` }}>
                    <p className="tr_tile_label">{tile.label}</p>
                    <p className="tr_tile_value">
                      {tile.prefix}
                      <RollingNumberLocalized target={tile.value} decimals={tile.decimals ?? 0} inView={groupsInView} locale={locale} />
                      {tile.suffix}
                    </p>
                    {tile.unit && <p className="tr_tile_unit">{tile.unit}</p>}
                    {tile.description && <p className="tr_tile_desc">{tile.description}</p>}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
